import React from 'react'
import PropTypes from 'prop-types'

import styles from '../sign-up.css'

const Step = ({ current, total }) => (
  <div className={styles.step}>
    {`STEP ${current} OF ${total}`}
  </div>
)

Step.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
}

export default Step
